const ClientModel = {
  logo: "object",
}

export default ClientModel
